// @flow

import * as React from 'react';

import { Button, Footer } from '@sonyged/ext-proc';
import { Flex, Text } from '@sonyged/proc-ui';
import css from '@styled-system/css';
import styled from 'styled-components';

import { Pizza } from '../../pizza/fields/domain/pizza';
import { YesterdayPizzaPanel } from './YesterdayPizzaPanel';

type Props = {
  onNext: () => void,
  pizza: Pizza,
  star: number,
  sale: number,
};

class PizzaOrderView extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { onNext, pizza, sale, star } = this.props;

    return (
      <div className="pizza-inner-view">
        <div className={'proc-contents padding relative'}>
          <Container>
            <Heading>昨日のピザ</Heading>
            <YesterdayPizzaPanel pizza={pizza} sale={sale} star={star} />
            <span className="dummy" />
          </Container>
        </div>
        <Footer.nav className="tertiary100-bg-color" shadow={false}>
          <Button.attention onClick={onNext}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }
}

export default PizzaOrderView;

const Container = styled(Flex)(
  css({
    flex: 1,
    minHeight: 0,
    bg: 'tertiary100',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 16,
  })
);

const Heading = styled(Text)(
  css({
    fontSize: '30px',
    textAlign: 'center',
    mt: ['50px', '50px', '75px'],
    mb: 0,
    color: 'secondary120',
    lineHeight: 1,
  })
);
